import { getSports } from '../../js/api/sports.js'
import { getSearchGames } from '../../js/api/search.js'
import { getSearchingGames } from "../templates/search-games.js";
import { _t } from '../../services/TranslationService.js';
import { gotoGame, registerFirstTime } from '../../js/api/liveCasino.js';
import IframeModal from './IframeModal.js';
import { getLogo, getTextLogo, getTitle, shouldOpenGamesWithIframe } from '../../js/constants/global-variables.js';

let sports = [];
let Leftpanel = {
    render: async () => {
        let frequentlyPlayedSportsView = '';
        const blockedSports = JSON.parse(
            localStorage.getItem("blockedSports") ?? "[]"
        );
        let sportsView = '';

        sports = await getSports();
        sports = sports.filter(
            (sport) => !blockedSports.includes(sport.id.toString())
        );
        //console.log(sports);

        if (sports && !sports.length == 0) {
            sports.forEach((sport, index) => {
                // <a href="#/p/${post.id}">${post.title}</a>
                sportsView = sportsView + `<a class="menuItem" href="#/categories/${sport.id}" data-id="${sport.id}">
                    <img src="img/${sport.name.toLowerCase().replaceAll(' ', '-')}.svg" onerror="if (this.src != 'error.jpg') this.src = 'img/soccer.svg';" />
                    ${_t(sport.name)}
                    </a>`;

                if (index < 2) {
                    frequentlyPlayedSportsView = frequentlyPlayedSportsView + `<a class="menuItem" href="#/categories/${sport.id}" data-id="${sport.id}">
                            <img src="img/${sport.name.toLowerCase().replaceAll(' ', '-')}.svg" onerror="if (this.src != 'error.jpg') this.src = 'img/soccer.svg';" />
                            ${_t(sport.name)}
                        </a>`;
                }
            });
        }
        const user_casino = true;

        const casino_enabled = localStorage.getItem('casino_enabled') === '1';
        const virtualEnabled = localStorage.getItem('virtualEnabled') === '1';
        const starCasinoEnabled = localStorage.getItem('starCasinoEnabled') === '1';
        const liveCasinoEnabled = localStorage.getItem('liveCasinoEnabled') === '1';
        const vipCasinoEnabled = localStorage.getItem('vipCasinoEnabled') === '1';

        const enableOldSlots = location.host === 'eccoplay365.com' || location.host === 'localhost:8080';

        let view = `
            <div class="eventShown"></div>
              <section class="leftPanel">
                <div class="menuHolder">
                    <div class="side-menu-logo" hidden>
                      ${
                        getTextLogo() ? `<span>${getTextLogo()}</span>` : `<img src="${getLogo()}" alt="${getTitle()}" />`
                      }
                    </div>
                    <div class="mainLeftMenuItem">
                        <a class="leftMenuHome active" id="sportsLeftBtn">
                            <svg id="sports_icon" data-name="sports icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs></defs><path d="M31.05,15.33a12.11,12.11,0,0,0-2.57-3.83,12.49,12.49,0,0,0-3.81-2.57,12.19,12.19,0,0,0-9.34,0,12.25,12.25,0,0,0-3.81,2.57A12,12,0,0,0,9,24.67a11.36,11.36,0,0,0,2.57,3.8A11.6,11.6,0,0,0,15.33,31a11.84,11.84,0,0,0,9.34,0,11.6,11.6,0,0,0,3.81-2.57,11.36,11.36,0,0,0,2.57-3.8,12,12,0,0,0,0-9.34ZM13.58,11a3.43,3.43,0,0,0,.33-.24c.13-.1.26-.18.4-.27l.14-.08a12.41,12.41,0,0,1,1.27-.62A11.09,11.09,0,0,1,20,9a10.7,10.7,0,0,1,2.92.39,5.38,5.38,0,0,0-1.6,1.09,9.38,9.38,0,0,0-1.91,0,11.87,11.87,0,0,0-2.52.56,10.13,10.13,0,0,0-1.74.8c-.61-.22-1.39-.48-1.76-.6C13.41,11.2,13.53,11.08,13.58,11ZM24.1,13.92l-2,5.41-4.73.89c-2.68-2.76-5.25-3.78-2.4-7.49a9.48,9.48,0,0,1,2.14-1.07,9.85,9.85,0,0,1,2.33-.51,9.38,9.38,0,0,1,1.91,0ZM10,17.48a9,9,0,0,0-.56,2.11A9.38,9.38,0,0,0,9.29,22c-.09-.2-.16-.34-.23-.48l0-.22C9,20.88,9,20.44,9,20a10.91,10.91,0,0,1,.75-4l0-.05.21-.5A12.84,12.84,0,0,0,10,17.48Zm.38,6.33A14.12,14.12,0,0,1,10,22.09a10.63,10.63,0,0,1,.07-2.4,9.27,9.27,0,0,1,.45-1.7c2.92-2.47,3.93.27,6.29,2.72l-.4,4.34C13,26.21,12.64,27.16,10.33,23.81Zm7.6,7-.32-.06-.13,0-.36-.09-.31-.09-.19-.06-.31-.11-.19-.07-.4-.16-.05,0a4.9,4.9,0,0,1-.52-.24,10.87,10.87,0,0,1-2.07-1.33c1.06-1.89-1.55-1.11,3.7-2.86l4.38,1.89C22,30.94,22.08,30.68,17.93,30.82ZM29,26.26q-.3.43-.63.84c-.2.23-.41.46-.63.68a11.35,11.35,0,0,1-1.18,1c-3.22,2.25-4.08,1.3-4.74-1.4L25,24.18c3.53-.32,4-1.34,4.28,1.81A2.22,2.22,0,0,0,29,26.26ZM25,23.45l-2.18-3.83,2-5.41,2.8.19A10,10,0,0,1,29.14,16a8.85,8.85,0,0,1,1.29,2.45C29.82,23.91,29.58,23,25,23.45Zm5.56-6.53a10.54,10.54,0,0,0-.82-1.33,10.74,10.74,0,0,0-1.79-1.84,5.48,5.48,0,0,0-1.37-2.6h0l.13.1.07.06A10.44,10.44,0,0,1,28.5,13a9.8,9.8,0,0,1,.63.85,10.38,10.38,0,0,1,1,1.86,10.82,10.82,0,0,1,.44,1.2S30.55,16.92,30.55,16.92Z" class="sc-1wcnnw2-0 fcJusf"></path></svg>
                            <span>${_t('Sports')}</span>
                        </a>
                        <a class="leftMenuInPlay" href="#/InPlay">
                            <svg id="live_icon" data-name="live icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs></defs><path d="M35.65,26.43V13.53A2.49,2.49,0,0,0,33.2,11H7a2.64,2.64,0,0,0-2.6,2.6v12.9A2.58,2.58,0,0,0,7,29h26.2a2.5,2.5,0,0,0,2.5-2.5Zm-16.19-4a2.5,2.5,0,0,1,0-4.88Zm1.08-4.88a2.5,2.5,0,0,1,0,4.88ZM5.4,17.38H8a.21.21,0,0,1,.2.2v4.7a.22.22,0,0,1-.2.2H5.4Zm0,9.1h0v-2.8H8a1.33,1.33,0,0,0,1.3-1.3V17.63A1.32,1.32,0,0,0,8,16.33H5.4v-2.8A1.44,1.44,0,0,1,6.8,12h0l12.66,0v4.5a3.49,3.49,0,0,0,0,6.9v4.48L7,28A1.61,1.61,0,0,1,5.45,26.48Zm29.15-3.9H32.1a.22.22,0,0,1-.2-.2V17.63a.21.21,0,0,1,.2-.2l2.5.05Zm0-6.2H32.1a1.32,1.32,0,0,0-1.3,1.3v4.7a1.33,1.33,0,0,0,1.3,1.3h2.5v2.8a1.52,1.52,0,0,1-1.5,1.4l-12.56,0V23.45a3.49,3.49,0,0,0,0-6.9v-4.5l12.56,0a1.54,1.54,0,0,1,1.5,1.5Z" class="sc-boqso5-0 gLaWKx"></path></svg>
                            <span>${_t('Live')}</span>
                        </a>
                        <a class="showMenuListedSlots">
                            <svg id="games_icon" data-name="games icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs></defs><path d="M31.59,10.18h-27a1.24,1.24,0,0,0-1.31,1.15V29.48a1.26,1.26,0,0,0,1.35,1.15h27A1.27,1.27,0,0,0,33,29.48V11.33a1.24,1.24,0,0,0-1.33-1.15ZM23.5,11.33h8.09v1.15H23.5Zm-18.88,0h8.1v1.15H4.62Zm0,18.15V13.62h8.1V29.48Zm17.54,0H14.07V28.33h8.09Zm0-2.3H14.07V11.33h8.09Zm1.34,2.3V13.62h8.09V29.48Z" class="sc-1812qqz-0 iWTKGz"></path><path d="M36.73,10.82a1.44,1.44,0,1,0-2,1.32v7.5a.57.57,0,0,1-.55.57H33v1.15h1.15a1.72,1.72,0,0,0,1.72-1.72h0v-7.5A1.47,1.47,0,0,0,36.73,10.82Z" class="sc-1812qqz-0 iWTKGz"></path><path d="M11.91,17.89,9.53,25.1a.3.3,0,0,1-.18.2,1,1,0,0,1-.43.05,3.41,3.41,0,0,1-1.23-.2c-.37-.13-.56-.28-.56-.44a.33.33,0,0,1,0-.14l2.19-4.18a1.77,1.77,0,0,0,.24-.64c0-.15-.1-.25-.28-.31a4.77,4.77,0,0,0-1-.08,5.72,5.72,0,0,0-1.24.1.58.58,0,0,0-.29.22,1.18,1.18,0,0,1-.29.3.62.62,0,0,1-.35.08.68.68,0,0,1-.62-.33,1.9,1.9,0,0,1-.21-1,2.8,2.8,0,0,1,.28-1.27A1.18,1.18,0,0,1,5.91,17a.66.66,0,0,1,.4-.17,2.14,2.14,0,0,1,.6.21,1.76,1.76,0,0,0,.72.12H11.4c.37,0,.56.14.56.42A.76.76,0,0,1,11.91,17.89Z" class="sc-1812qqz-0 iWTKGz"></path><path d="M30.8,17.89,28.43,25.1a.31.31,0,0,1-.19.2,1,1,0,0,1-.43.05,3.41,3.41,0,0,1-1.23-.2c-.37-.13-.55-.28-.55-.44a.24.24,0,0,1,0-.14l2.18-4.18a1.77,1.77,0,0,0,.24-.64c0-.15-.09-.25-.27-.31a4.77,4.77,0,0,0-1-.08,5.81,5.81,0,0,0-1.25.1.58.58,0,0,0-.29.22,1,1,0,0,1-.3.3.57.57,0,0,1-.34.08.68.68,0,0,1-.62-.33,1.73,1.73,0,0,1-.22-1,2.79,2.79,0,0,1,.24-1.27A1.57,1.57,0,0,1,24.8,17a.69.69,0,0,1,.41-.17,2,2,0,0,1,.59.21,1.81,1.81,0,0,0,.73.12h3.76c.38,0,.56.14.56.42A.59.59,0,0,1,30.8,17.89Z" class="sc-1812qqz-0 iWTKGz"></path><path d="M21.41,16,19,23.2a.29.29,0,0,1-.19.2,1,1,0,0,1-.43,0,3.44,3.44,0,0,1-1.23-.19c-.37-.14-.55-.28-.55-.44a.44.44,0,0,1,.05-.15l2.18-4.16a1.77,1.77,0,0,0,.24-.64c0-.15-.09-.25-.27-.31a4.77,4.77,0,0,0-1-.08,5.41,5.41,0,0,0-1.27.11.64.64,0,0,0-.29.22,1.11,1.11,0,0,1-.3.31.58.58,0,0,1-.34.07.68.68,0,0,1-.62-.33,1.73,1.73,0,0,1-.22-1,2.84,2.84,0,0,1,.28-1.31,1.57,1.57,0,0,1,.35-.42.74.74,0,0,1,.41-.16,2,2,0,0,1,.59.2,1.81,1.81,0,0,0,.73.12h3.77c.37,0,.55.14.55.42A1,1,0,0,1,21.41,16Z" class="sc-1812qqz-0 iWTKGz"></path></svg>
                            <span>${_t('Casino')}</span>
                        </a>
                        <a href="">
                            <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><defs></defs><path d="M33.08,16.7c-.1-2.27-2.26-3.11-3.45-3.23l-1,0a8.65,8.65,0,0,0-3.55-4.71c-2.26-1.43-6-2-9.81-1.59s-7,3.37-7.84,5.92A17.81,17.81,0,0,0,8.88,25.44c2.26,4.57,2,6.83,2,6.85l.68.11.69.11c0-.11.39-2.65-2.1-7.69a18.25,18.25,0,0,1-.92-2.24c2.23-.13,5.33,0,6.22.71a7.74,7.74,0,0,0,4.4,1.6c.15,0,2.51.09,5.08.09l2,0-1.35,4.9s-.47,1-2.82.71c-2.79-.31-5.37-2.75-5.4-2.78l-1,1a13.59,13.59,0,0,0,5,2.91l-.17,1.07,1.37.22.16-1a7.43,7.43,0,0,0,.78,0c2.79,0,3.36-1.64,3.39-1.75l1.47-5.35.46,0C32,24.7,33,22.8,33.08,21.8,33.08,21.68,33.17,19,33.08,16.7ZM15.41,8.52c3.48-.41,6.89.12,8.9,1.38a7.22,7.22,0,0,1,2.81,3.51l-5.82-.14a5.49,5.49,0,0,0-4.41,1.67,2.61,2.61,0,0,1-2.35.85H8.32a10.92,10.92,0,0,1,.41-2.31A8.37,8.37,0,0,1,15.41,8.52ZM31.69,21.7c0,.07-.22,1.64-3,1.8-3.37.19-8.8,0-8.86,0a6.49,6.49,0,0,1-3.54-1.27c-1.53-1.3-5.88-1.13-7.52-1a17.7,17.7,0,0,1-.52-4h6.26a4,4,0,0,0,3.38-1.29,4.15,4.15,0,0,1,3.34-1.22l8.28.19c.08,0,2.08.27,2.15,1.91C31.78,19,31.69,21.7,31.69,21.7Z" class="sc-5ztthk-0 iiIAgT"></path><path d="M21.61,16.83l-.6-.36c-.08.13-1.91,3.21,0,5.68l1.09-.86c-1.35-1.71,0-4.08.05-4.1Z" class="sc-5ztthk-0 iiIAgT"></path></svg>
                            <span>${_t('Virtual')}</span>
                        </a>
                    </div>
                    <div class="menuItemListed active">
                        <label>${_t('Home')}</label>
                        <a class="menuItem homeLeftBtn" href="~/../">
                            <i class="menu-item-icon"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="house" class="svg-inline--fa fa-house " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"></path></svg></i>
                            ${_t('Home')}
                        </a>

                        <label>${_t('Frequently Visited')}</label>
                        ${frequentlyPlayedSportsView}

                        <label>${_t('Lista e Plote e Sporteve')}</label>
                        ${sportsView}
                    </div>
                    <div class="slotsItemListed">
                    <a class="slotItemList" href="#/slots" ${enableOldSlots && casino_enabled ? '' : 'hidden'}>
                        <img src="https://content.stargame.solutions/api/game/icon2/298" alt="">
                        <span>${_t('Casino')}</span>
                    </a>
                    <a class="slotItemList" href="#/live-casino" ${liveCasinoEnabled ? '' : 'hidden'}>
                        <img src="img/game2.jpeg" alt="">
                        <span>${_t('Live Casino')}</span>
                    </a>
                    <a class="slotItemList" href="#/stargames" ${vipCasinoEnabled ? '' : 'hidden'}>
                        <img src="img/game7.jpeg" alt="">
                        <span>${_t('VIP Casino')}</span>
                    </a>
                    <a class="slotItemList" href="#/deluxe" ${starCasinoEnabled ? '' : 'hidden'}>
                        <img src="img/game3.jpg" alt="">
                        <span>${_t('GS Deluxe')}</span>
                    </a>
                    <a class="slotItemList" onclick="launchvirtualgames()" ${virtualEnabled ? '' : 'hidden'}>
                        <img src="img/game4.jpeg" alt="">
                        <span>${_t('Virtuale')}</span>
                    </a>
                    <a class="slotItemList rouletteBtn" hidden>
                        <img src="/vbet/user/src/img/games_icons/LuxRoulette.jpg" alt="">
                        <span>${_t('Roulette')}</span>
                    </a>
                    <a class="slotItemList" href="#/stargames?category=crash-games" ${vipCasinoEnabled ? '' : 'hidden'}>
                        <img src="img/crash-games.png" alt="${_t('Crash Games')}" />
                        <span>${_t('Crash Games')}</span>
                    </a>
                    <!-- <a class="slotItemList leftPanel-game" game="2046" ${starCasinoEnabled ? '' : 'hidden'}>
                        <img src="img/game5.jpeg" alt="">
                        <span>${_t('Aviator')}</span>
                    </a>
                    <a class="slotItemList leftPanel-game" game="2044" ${starCasinoEnabled ? '' : 'hidden'}>
                        <img src="img/game6.webp" alt="">
                        <span>Plinko Dare2Win</span>
                    </a> -->
                    </div>

                </div>
              </section>
        `
        return view
    },
    after_render: async () => {

        $('body').on('click', '#searchTrigger', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('body').addClass('showDescSearch');
            $('body .searchHolder').addClass('show');
            $('body .searchInputLabel').focus();
        });

        $('body').on('click', '.closeSearch', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('body').removeClass('showDescSearch');
            $('body .searchHolder').removeClass('show');
            $('body .clearSearch').click();
        });

        $('body').on('click', '.clearSearch', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('body .searchInputLabel').val('');
            document.getElementById('searchContent').innerHTML = '';
        });

        $('body').on('click', '.clearInput', function (e) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            $('body .searchInputLabel').val('');
            $('body .searchInputLabel').focus();
        });

        $(".leftPanel-game").on("click", async function (e) {
            if (
                !localStorage.getItem("access_token") ||
                localStorage.getItem("access_token") == ""
            ) {
                alert(_t('Login!'));
                return;
            }
            let key1;
            let key2;
            let sessionid;
            let userId = localStorage.getItem('user_id');
            const starCasinoEnabled = localStorage.getItem('starCasinoEnabled');

            if (starCasinoEnabled != "1") {
                alert(_t('Nuk keni qasje ne lojet e Casino!'));
                return;
            }

            const response = await registerFirstTime();
    
            if (response && response.token !== null) {
                localStorage.setItem('access_token', response.token.jwt);
            }

            let checkStatus = await gotoGame();
            key1 = checkStatus.key1;
            key2 = checkStatus.key2;
            sessionid = checkStatus.sessionid;

            let gameId = $(e.currentTarget).attr('game');
            let gameName = $(e.currentTarget).children('span').text();

            const gameLink = `https://apiserver.solutions/showgame?gameid=${gameId}&sid=${sessionid}&key1=${key1}&key2=${key2}&username=${userId}&uwidth=auto&uheight=auto`;       

            if (shouldOpenGamesWithIframe()) {
                IframeModal.loadIframe(gameLink, true);
                IframeModal.show(gameName);
            } else {
                IframeModal.openInNewTab(gameLink);
            }
        });

        $( "body .searchInputLabel" ).on('keyup',delay(async function(e) {

            let getSearchValue = e.currentTarget.value;
            let searchView = '';

            if (e.currentTarget.value.length >= 3) {
                let searchValues = await getSearchGames(getSearchValue);
                if (!searchValues.length == 0) {
                    const uniqueDates = [
                        ...new Set(searchValues.map((item) => item.game_date)),
                    ].sort();

                    let searchGamesView = "";

                    uniqueDates.forEach((date) => {
                        let singleDateView = "";

                        searchValues
                            .filter((a) => a.game_date === date)
                            .map((searchValue) => {
                                if (!searchValue.odd || searchValue.id == 372481) {
                                    return;
                                }
                                singleDateView += getSearchingGames(searchValue);
                            });

                        if (singleDateView == "") {
                            return;
                        } else {
                            searchGamesView =
                                searchGamesView +
                                ` <div class="searchLabelGroup">
                            <div class="searchLabel">
                               <span>${date}</span>
                            </div>
                            <div class="search-games">
                              ${singleDateView}
                            </div>
                        </div>`;
                        }
                    });
                    $('body #searchContent').html(searchGamesView);
                }
            }
            if (e.currentTarget.value.length == 0) {
                $('body .clearSearch').click();
            }
        }, 500));
        function delay(callback, ms) {
            var timer = 0;
            return function () {
                var context = this, args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    callback.apply(context, args);
                }, ms || 0);
            };
        }

        $('body').on('click', '.showMenuListedSlots', function (e) {
            $(e.currentTarget).parent().children().removeClass('active');
            $(e.currentTarget).addClass('active');

            $('body .slotsItemListed').addClass('active');
            $('body .menuItemListed').removeClass('active');
        });

        $('body').on('click', '#sportsLeftBtn', function (e) {
            $(e.currentTarget).parent().children().removeClass('active');
            $(e.currentTarget).addClass('active');
            $('body .menuItemListed').addClass('active');
            $('body .slotsItemListed').removeClass('active');
        });

        $('body').on('click', '.slotItemList', function (e) {
            $('.profileNav a').removeClass('active');
            $('.mainMenuHolder a').removeClass('active');
            $('body').removeClass('menuOpened');
        });
        $('body').on('click', '.leftMenuInPlay', function (e) {
                $('body').removeClass('menuOpened');
        });


    }
};

export { Leftpanel, sports };
